import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const servicePlan: IMcAppType = {
  name: "servicePlan_KRAKEN",
  path: "/my/service/:serviceType/:agreementId/plan",
  description: "Plan details",
  parameters: {
    required: ["serviceType", "agreementId"],
    properties: {
      agreementId: CommonParameters.agreementId,
      serviceType: CommonParameters.serviceType,
    },
  },
  navFlow: NavFlow.STANDARD,
  title: "Plan details",
  parent: Tab.MORE,

  conditions: {
    intent: "servicePlan",
    customerType: CustomerType.kraken,
  },
};
